var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7905 4.10372e-06L15.4375 3.67174e-06C18.5258 9.05878 23.6729 12.353 29.4375 12.9706L29.4375 15.0294C23.6729 15.647 18.5258 18.9411 15.4376 28L13.7905 28C10.7023 18.9411 5.76114 15.647 -0.00357587 15.0294L-0.00357641 12.9706C5.76114 12.353 10.7023 9.05878 13.7905 4.10372e-06Z",
    fill: "#B00017"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsmall);
export default __webpack_public_path__ + "static/media/starsmall.7d3c4378c175f3410244c823c45dea9a.svg";
export { ForwardRef as ReactComponent };